$(function () {

    $('[data-toggle=lightbox]').on('click', function (event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });

    $('.js-send-form').on('submit', function (e) {
        e.preventDefault();
        var form = $(this);
        var action = $(this).attr('action');

        form.find('input').removeClass('is-invalid');
        form.find('.invalid-feedback').html('').hide();

        $.ajax({
            url: action,
            type: "POST",
            data: form.serialize(),
            dataType: "json",
            beforeSend: function () {
            },
            error: function (jqXHR, exception) {
                var responseText = jQuery.parseJSON(jqXHR.responseText);

                $.each(responseText.errors, function (index, value) {

                    var input = form.find('input[name=' + index + ']:first');

                    input.addClass('is-invalid');

                    var text = '';
                    $.each(value, function (index, value) {
                        text += value;
                    });

                    input.siblings('.invalid-feedback').html(text).show();
                });
            },
            success: function (json) {
                form.find('.js-success-message').html(json.message).addClass('success-message-text');
                console.log('dataLayer');
                dataLayer.push({'event': 'order'});

            }
        });
    });

    $("input[name=phone]").mask("+9(999)999-9999");

});
